import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import matter from 'gray-matter'
import PostCard from '../components/PostCard'

const BlogPostPage = () => {
    const { slug } = useParams()
    const [content, setContent] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {
        const loadPost = async () => {
            try {
                const response = await fetch(`/BlogContent/${slug}/index.md`)
                if (!response.ok) throw new Error('Post not found.')

                const rawMarkdown = await response.text()
                const { content: markdownContent, data: frontmatter } = matter(rawMarkdown)

                const [preview, rest] = markdownContent.split('<!--more-->')
                const previewHTML = marked.parse(preview)
                const fullHTML = rest ? marked.parse(rest) : ''

                const parsedContent = {
                    preview: previewHTML,
                    full: fullHTML,
                    isExpandable: !!rest,
                    meta: {
                        ...frontmatter,
                        tags: frontmatter.tags || [],
                    },
                }

                setContent(parsedContent)
            } catch (err) {
                setError(err.message)
            }
        }

        loadPost()
    }, [slug])

    if (error) {
        return (
            <div className="blog-page">
                <div className="container">
                    <div className="error">{error}</div>
                </div>
            </div>
        )
    }

    if (!content) {
        return (
            <div className="blog-page">
                <div className="container">
                    <div className="loader">Loading post...</div>
                </div>
            </div>
        )
    }

    return (
        <div className="blog-page">
            <div className="container">
                <div className="posts-wrapper">
                    <PostCard
                        path={`BlogContent/${slug}/index.md`}
                        content={content}
                        isSeparate={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default BlogPostPage
